




















































































































































































import Vue from "vue";
import { NavItem } from "../../types/interface/NavItem";
import { EhrModule } from "../../types/general/EhrModule";
import NotificationCenter from "./NotificationCenter.vue";
import $ from "jquery";
import { NavItemPosition } from "../../types/interface/NavItemPosition";
import { EhrNotification } from "../../types/general/EhrNotification";
import { NavItemType } from "../../types/interface/NavItemType";
import {moduleRepository} from "../repositories/moduleRepository";
declare var GLOBAL_applicationName: string;
declare var GLOBAL_currentUser: string;
export default Vue.extend({
  name: "ehr-navigation",
  components: { NotificationCenter },
  props: {
    activeItem: {
      type: String,
    },
  },
  mounted() {
    this.getData();
    $(this.$refs.vuedropdown).on("hide.bs.dropdown", this.onNotifClose);
  },
  data() {
    return {
      modules: [] as EhrModule[],
      navData: [
        {
          name: "home",
          label: "Startpagina",
          icon: "home",
          position: NavItemPosition.Left,
          type: NavItemType.Normal,
          url: document.baseURI + "home/index",
          notifications: [],
        },
      ] as Array<NavItem>,
      notificationCenter: {
        notifications: [] as Array<EhrNotification>,
        update: 0,
      },
    };
  },
  computed: {
    leftNavData(): Array<NavItem> {
      return this.navData.filter(function(item: NavItem) {
        return item.position === NavItemPosition.Left;
      });
    },
    rightNavData(): Array<NavItem> {
      return this.navData.filter(function(item) {
        return item.position === NavItemPosition.Right;
      });
    },
    currentUser(): string {
      return GLOBAL_currentUser;
    },
    applicationName(): string {
      return GLOBAL_applicationName;
    },
    baseURL(): string {
      return document.baseURI;
    },
    amountNotifications(): number {
      return this.notificationCenter.notifications.filter(
        (element: EhrNotification) => {
          return !element.read;
        }
      ).length;
    },
  },
  methods: {
    isActiveItem(navItem: NavItem): boolean {
      return navItem.name === this.activeItem;
    },
    isDropdown(navItem: NavItem): boolean {
      return navItem.type === NavItemType.Dropdown;
    },
    hasNotifications(navItem: NavItem) {
      return navItem.notifications.length !== 0;
    },
    onNotificationsChanged(event) {
      this.notificationCenter.notifications = event;
    },
    onNotifClose(): void {
      this.notificationCenter.update++;
    },
    async getData() {
      const data = await moduleRepository.ehrModulesAndTiles();
      this.modules = data.modules;
      const moduleNavData: NavItem[] = this.modules.map(module => ({
        name: module.path,
        label: module.name,
        position: NavItemPosition.Left,
        icon: module.fontAwesomeIcon,
        type: NavItemType.Normal,
        url: document.baseURI + module.path,
        notifications: [],
      }));
      this.navData = this.navData.concat(moduleNavData);
    },
  },
});
